"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
function default_1() {
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    return ((0, jsx_runtime_1.jsx)(Skeleton_1.default, { animation: "wave", variant: "rectangular", sx: { width: '100%', height: 'auto', aspectRatio: maxWidth768 ? '207 / 80' : '5 / 2' } }));
}
exports.default = default_1;
